import { useCallback, useState } from "react"
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material"
import { useAvatarChangeBlockTOHMutation } from "../../core/api/toh-user-api"

const TohAvatarChangeUnblockControl = ({ disabled, userId }) => {
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [unblock, { isLoading }] = useAvatarChangeBlockTOHMutation()

    const handleOpenConfirm = useCallback(() => {
        setConfirmOpen(true)
    }, [])

    const handleCloseConfirm = useCallback(() => {
        setConfirmOpen(false)
    }, [])

    const handleConfirm = useCallback(async () => {
        await unblock({ userId, blocked: false })
        setConfirmOpen(false)
    }, [unblock, userId])

    return (
        <>
            <Button
                fullWidth
                size="small"
                loading={isLoading}
                disabled={disabled}
                onClick={handleOpenConfirm}
            >
                Unblock
            </Button>
            <Dialog open={confirmOpen} onClose={handleCloseConfirm}>
                <DialogTitle>Unblock avatar change for '{userId}'?</DialogTitle>
                <DialogActions>
                    <Button onClick={handleCloseConfirm}>Cancel</Button>
                    <Button variant="contained" loading={isLoading} onClick={handleConfirm}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default TohAvatarChangeUnblockControl
